import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, TextField, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import NavBar from '../NavBar.js';
import { Footer } from '../Footer/Footer.js';
import { useForm } from 'react-hook-form';
import { post_resetPassword, getCsrfToken } from '../../actions/index.js';
import { LOGGED_IN_USER } from '../../actions/actionTypes.js';
import { newPassword, reenterPassword, resetPassword, updatePassword } from '../../constants/Forms';

import './ForgetPassword.css';

export const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useParams();

  const { csrfToken, jwt } = useSelector(({ userReducer: { csrfToken, jwt } }) => ({
    csrfToken,
    jwt,
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    clearErrors,
  } = useForm();

  useEffect(() => {
    if (!csrfToken) {
      dispatch(getCsrfToken());
    }
  }, [csrfToken]);

  useEffect(() => {
    if (jwt) {
      navigate('/dashboard');
    }
  }, [jwt]);

  const onSubmit = async (data) => {
    // Clear error if it previously existed
    clearErrors('passwordMismatch');

    dispatch(post_resetPassword({ token, newPassword: data.password, csrfToken }));
  };

  return (
    <>
      <NavBar currentPath="" />
      <div className="forget-password-wrapper">
        <header className="forget-password-header-wrapper">
          <div className="sign-up-log-in-image-wrapper">
            <img
              src="https://res.cloudinary.com/amunoali/image/upload/v1744215112/finance-auto-mortgage_lvbeob.png"
              className="sign-up-log-in-image"
            />
          </div>
          <form className="forget-password-form" onSubmit={handleSubmit(onSubmit)}>
            <h5 className="forget-password-header">{resetPassword} </h5>

            {Object.values(errors).map((error, index) => (
              <p className="errorMessage" key={index}>
                {error.message}
              </p>
            ))}

            <div className="forget-password-input-wrapper">
              <label className="resetPassword">{newPassword}</label>
              <TextField
                fullWidth
                variant="outlined"
                type={showPassword ? 'text' : 'password'}
                autoComplete="off"
                className="password-input"
                {...register('password', {
                  required: 'Password is required.',
                  minLength: {
                    value: 8,
                    message: 'Password must be at least 8 characters',
                  },
                  pattern: {
                    value: /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
                    message:
                      'Password must include: uppercase letter, numbers, and special character',
                  },
                })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <label className="resetPassword">{reenterPassword}</label>
              <TextField
                fullWidth
                variant="outlined"
                type={showPassword ? 'text' : 'password'}
                autoComplete="off"
                className="password-input"
                {...register('confirmPassword', {
                  required: 'Please confirm your password.',
                  validate: (value) => value === getValues('password') || 'Passwords do not match',
                })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div>
              <Button className="submitBtn" type="submit">
                {updatePassword}
              </Button>
            </div>
          </form>
        </header>
      </div>
      <Footer currentPath={'/reset_password'} />
    </>
  );
};
